import { createSlice } from '@reduxjs/toolkit';
import { addNewModel, editModel, getAllModels, getModelByMakeId } from './modelsService';

const initialState = {
  allModels: {
    isModelsLoading: null,
    isModelsSuccess: null,
    modelsMessage: null,
    pageCount: 0,
    models: [],
  },
  newModel: {
    isModelCreating: null,
    isModelCreated: null,
    modelCreationMsg: null,
  },

  editedModel: {
    isEditingModel: null,
    isModelEdited: null,
    modelEditedMsg: null
  },

  allModelsByMakeId: {
    isModelsByMakeLoading: null,
    isModelsByMakeSuccess: null,
    modelsByMakeMessage: null,
    modelsByMake: [],
  },
};

const modelsSlice = createSlice({
  name: 'model',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllModels.pending, (state) => {
        state.allModels = {
          ...initialState.allModels, // Reset to initial state
          isModelsLoading: true,
          modelsMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllModels.rejected, (state, action) => {
        state.allModels = {
          ...initialState.allModels,
          isModelsLoading: false,
          isModelsSuccess: false,
          modelsMessage: action.payload || 'Error occurred while fetching models',
        };
      })

      // FULFILLED
      .addCase(getAllModels.fulfilled, (state, action) => {
        state.allModels = {
          ...initialState.allModels,
          isModelsLoading: false,
          isModelsSuccess: true,
          pageCount: action.payload.pageCount || 0,
          models: action.payload.data || [],
        };
      });

    //Model creating
    builder
      .addCase(addNewModel.pending, (state) => {
        state.newModel = {
          ...initialState.newModel, // Reset to initial state
          isModelCreating: true,
          modelCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewModel.rejected, (state, action) => {
        state.newModel = {
          ...initialState.newModel,
          isModelCreating: false,
          isModelCreated: false,
          modelCreationMsg: action.payload || 'Error occurred while creating the model.',
        };
      })

      // FULFILLED
      .addCase(addNewModel.fulfilled, (state, action) => {
        state.newModel = {
          ...initialState.newModel,
          isModelCreating: false,
          isModelCreated: true,
          modelCreationMsg: action.payload || 'Successfully created the model.',
        };
      });

    //Model editing
    builder
      .addCase(editModel.pending, (state) => {
        state.editedModel = {
          ...initialState.editedModel, // Reset to initial state
          isEditingModel: true,
          modelEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editModel.rejected, (state, action) => {
        state.editedModel = {
          ...initialState.editedModel, // Reset to initial state
          isEditingModel: false,
          isModelEdited: false,
          modelEditedMsg: action.payload || 'Error occurred while editing the model.',
        };
      })

      // FULFILLED
      .addCase(editModel.fulfilled, (state, action) => {
        state.editedModel = {
          ...initialState.editedModel, // Reset to initial state
          isEditingModel: false,
          isModelEdited: true,
          modelEditedMsg: action.payload || 'Successfully edited the model.',
        };
      });

      //Models by Make
      builder.addCase(getModelByMakeId.pending, (state) => {
        state.allModelsByMakeId = {
          ...initialState.allModelsByMakeId, // Reset to initial state
          isModelsByMakeLoading: true,
          modelsByMakeMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getModelByMakeId.rejected, (state, action) => {
        state.allModelsByMakeId = {
          ...initialState.allModelsByMakeId,
          isModelsByMakeLoading: false,
          isModelsByMakeSuccess: false,
          modelsByMakeMessage: action.payload || 'Error occurred while fetching models',
        };
      })

      // FULFILLED
      .addCase(getModelByMakeId.fulfilled, (state, action) => {
        state.allModelsByMakeId = {
          ...initialState.allModelsByMakeId,
          isModelsByMakeLoading: false,
          isModelsByMakeSuccess: true,
          modelsByMake: action.payload || [],
        };
      });
  },
});

export default modelsSlice.reducer;
